import { render } from "./OryzoHeader.vue?vue&type=template&id=2e5eb6df&scoped=true"
import script from "./OryzoHeader.vue?vue&type=script&lang=js"
export * from "./OryzoHeader.vue?vue&type=script&lang=js"

import "./OryzoHeader.vue?vue&type=style&index=0&id=2e5eb6df&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e5eb6df"]])

export default __exports__